<template>
  <div>
    <template v-if="!isIncomplete">
      <template v-if="canSubscribe">
        <div v-show="step == 1">
          <v-row class="mb-2" v-if="showAlert">
            <v-col>
              <v-alert type="info">
                Seu período de teste terminou. Assine já e economize tempo com o
                Psicoplanner!
              </v-alert>
            </v-col>
          </v-row>
          <h2>Planos de acordo com a sua necessidade...</h2>
          <PlanSelection @input="handlePlanSelection($event)" />
        </div>
        <div v-show="step == 2">
          <h2>Informe os dados para assinatura...</h2>
          <BaseBillingInformationForm v-model="form" class="mt-10" />
          <v-row class="text-right">
            <v-col>
              <v-btn @click="step--" text class="mr-2"> Voltar </v-btn>
              <v-btn @click="store()" color="primary"> Confirmar </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-show="step == 3">
          <v-row class="d-flex justify-center">
            <AppInvoice :charge="charge" />
          </v-row>
        </div>
      </template>
      <template v-else>
        <div class="text-center">
          <div class="my-6">Você já possui uma assinatura Ativa!</div>
          <div class="my-6">
            <v-btn color="primary" @click="$router.push('/')()"> Voltar </v-btn>
          </div>
        </div>
      </template>
    </template>
    <template v-if="isIncomplete">
      <v-row class="d-flex justify-center">
        <AppInvoiceDialog @update="$emit('update')" ref="AppInvoiceDialog" />
      </v-row>
    </template>
  </div>
</template>

<script>
import BaseBillingInformationForm from "@/components/subscription/forms/BaseBillingInformationForm.vue";
import AppInvoiceDialog from "@/components/subscription/sections/AppInvoiceDialog.vue";
import PlanSelection from "@/components/subscription/sections/PlanSelectionV2.vue";
import AppInvoice from "@/components/subscription/sections/AppInvoice.vue";

export default {
  components: {
    BaseBillingInformationForm,
    AppInvoiceDialog,
    PlanSelection,
    AppInvoice,
  },

  data() {
    return {
      step: 1,
      form: {
        plan: {},
        billingInformation: {},
      },

      defaultVendor: "efi",
      updateVendorTo: "efi",
      charge: {},
    };
  },

  created() {
    this.refreshUserData();
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    isOnTrial(state, getters) {
      if (getters.hasSubscription) {
        return false;
      }

      return true;
    },

    isOnTrial() {
      return this.$store.getters["subscription/isOnTrial"];
    },

    isTrialEnded() {
      return this.$store.getters["subscription/isTrialEnded"];
    },

    canSubscribe() {
      return this.$store.getters["subscription/canSubscribe"];
    },

    isIncomplete() {
      return this.$store.getters["subscription/incomplete"];
    },

    showAlert() {
      return this.isOnTrial && this.isTrialEnded;
    },
  },

  mounted() {
    if (this.isIncomplete) {
      this.$refs.AppInvoiceDialog.open();
    }
  },

  methods: {
    refreshUserData() {
      this.$auth
        .getLoginData()
        .then((response) => {
          this.$loading.finish();
          this.processSaved();
        })
        .catch((response) => {
          this.$loading.finish();
        });
    },

    handlePlanSelection(plan) {
      this.form.plan = plan;
      this.step++;
    },

    async store() {
      if (this.updateVendorTo) {
        this.form.vendor = this.updateVendorTo;
      }

      this.$loading.start();
      try {
        await this.$http
          .store("subscription/efi/billing-information", this.form)
          .then(async (response) => {
            this.form.billingInformation = response;
            await this.storeSubscription();
            this.$loading.finish();
          })
          .catch((error) => this.$loading.finish());
      } catch (error) {
        this.$loading.finish();
      }
    },
    async storeSubscription() {
      await this.$http
        .store("subscription/efi/checkout", this.form)
        .then((response) => {
          this.step++;
          this.charge = response.charge;
          this.checkSubscription(response.subscription.id);
        })
        .catch((error) => console.log(error));
    },

    async checkSubscription(subscription_id) {
      await this.$http
        .show("subscription/efi/checkout", subscription_id)
        .then((response) => {
          var isPaid = response.subscriptionIsPaid;

          if (isPaid) {
            this.$auth
              .getLoginData()
              .then((response) => this.$router.push("/dashboard"))
              .catch((error) => console.log(error));
          }
          if (!isPaid) {
            setTimeout(() => this.checkSubscription(subscription_id), 5000);
          }
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style></style>
